import { blockType } from "../constants";
import { FieldBlockSchema } from "../schema";
import type { Field } from "../types";

export const map: Field["map"] = (block) => {
  const config = block.config?.valueOf();
  return {
    type: blockType,
    config: FieldBlockSchema.shape.config.parse({
      id: block.id,
      ...(typeof config === "object" ? config : {}),
    }),
  };
};
